import throwAwaySvg from '../assets/throw-away.svg';
import lovingItSvg from '../assets/loving-it.svg';

interface NoContentMessage {
  title: any;
  description: any;
  image: string;
}

export interface RoutesPage {
  id: string;
  label: any | string;
  path: string;
  hasActions?: boolean;
  canUpload?: boolean;
  disableSort?: boolean;
  queryParams?: Record<string, string | number | boolean>;
  folder?: any;
  isFolderPage?: boolean;
  noContentMessage: (isSearchingOrFiltering: boolean) => NoContentMessage;
}



export const MintedPage: RoutesPage = {
  id: 'minted',
  label: 'Minted',
  path: '/drive/minted',
  isFolderPage: true,
  noContentMessage: () => ({
    title: 'Nothing is Minted',
    description: 'Pleae Mint file first then come back here',
    image: lovingItSvg,
  }),
};

export const WalletPage: RoutesPage = {
  id: 'wallets',
  label: 'Wallets',
  path: '/drive/wallets',
  noContentMessage: () => ({
    title: 'Nothing',
    description: 'Please add wallet first then come back here',
    image: throwAwaySvg,
  }),
};

export const TransactionsPage: RoutesPage = {
  id: 'transactions',
  label: 'Transactions',
  path: '/transactions',
  noContentMessage: () => ({
    title: 'No transactions',
    description: 'You have not added any transactions yet',
    image: throwAwaySvg,
  }),
};

export const PaymentHistoryPage: RoutesPage = {
  id: 'payment_history',
  label: 'Payment History',
  path: '/payment-history',
  noContentMessage: () => ({
    title: 'No payments',
    description: 'You have not added any payments yet',
    image: throwAwaySvg,
  }),
};

export const DRIVE_PAGES = [MintedPage, WalletPage, TransactionsPage, PaymentHistoryPage];
